<template>
  <div class="dashboard-page">
    <Menu v-if="user_ready"/>
    <RouteStepper :steps="steps"/>
    <div class="tablesContainer ">
      <div class='expansionContainer'>
        <div class="container">
          <div class="search-wrap">
            <md-autocomplete v-model="searchKeyword" md-layout="box" :md-options="[]">
    
              <label><img alt="Folder Button"
                          class="folderButton margin-small--right search-icon"
                          src="@/assets/img/icons/search.svg"
              /> Search..</label>
            </md-autocomplete>
          </div>
          <Expansion :clients="filteredClients"/>
          <AddNewClient v-if="accountView"/>  
        </div>
      </div>
        <Actions v-if="filteredClients.length" :timeline="timeline"/>
    </div>

  </div>
</template>

<script>
import Menu from '@/components/Menu.vue';
import RouteStepper from '@/components/RouteStepper';
import Expansion from "@/components/pagesComponents/dashboard/Expansion.vue";
import AddNewClient from "@/components/pagesComponents/dashboard/AddNewClient.vue"
import Actions from "@/components/pagesComponents/dashboard/Actions.vue"
import viewMI from '@/mixins/viewMI.js'

export default {
  // props: ['clients','brands'],
  mixins: [viewMI],
  data() {
    return {
      searchKeyword: undefined,
      clients: [],
      accountView: false,
      designerView: false,
      timeline: [],
      user_ready: false,
      steps: [
          {'name':'Clients',path: "/dashboard"},
        ],
    }
  },
  components: {
    Menu,
    Expansion,
    AddNewClient,
    RouteStepper,
    Actions
  },
  methods: {
    userReady() {
      this.user_ready = true;
      this.refreshClients()
      this.refreshTimeline();

    },
    refreshClients() {
      console.log('refreshClients dashboard')
      var _this = this;
      if (this.$store.state.user.user_type === 'designer') {
        this.designerView = true;
      }
      if (this.$store.state.user.user_type === 'client') {
        _this.get('user_to_brand',
            {
              params: {
                where: [['where', 'user_id', this.$store.state.user.id]],
              }
            },
            function (resp) {

              var brand_ids = []
              for (var i = 0; i < resp.data.user_to_brand.length; i++) {
                brand_ids.push(resp.data.user_to_brand[i].brand_id)
              }
              _this.get('brand',
                  {
                    params: {
                      where: [['where_in', 'id', brand_ids]],
                      relations: 1,
                      relations_params: {
                        client: {
                          relations: 1,
                          relations_params: {
                            brand: {
                              relations: 1,
                              where: [['where_in', 'id', brand_ids]],
                            }
                          }
                        }
                      }
                    }
                  },
                  function (resp) {
                    _this.clients = [];
                    resp.data.brand.forEach(b=>{
                      if (_this.clients.find(c=> parseInt(c.id) == parseInt(b.client.id))  == null)
                        _this.clients.push(b.client);

                    })
                    //_this.$router.push('/client/' + resp.data.brand[0].client.slug);
                  }
              )
            }
        )
      } else {
        if (this.$store.state.user.user_type === 'account')
        {
          this.accountView = true;
        }
        _this.get('client',
            {
              params: {
                relations: 1,
                relations_params: {
                  brand: {
                    relations: 1
                  }
                }
              }
            },
            function (resp) {
              //console.log('clients', resp)
              _this.clients = resp.data.client
            }
        )
      }
    },
    refreshCampaigns() {
      var _this = this;

      _this.get('client',
          {
            params: {
              relations: 1,
              relations_params: {
                brand: {
                  relations: 1
                }
              }
            }
          },
          function (resp) {
            //console.log('clients', resp)
            _this.clients = resp.data.client
          }
      )
    }
  },
  computed: {
    keyword() {
      return (this.searchKeyword ?? '').toLowerCase().trim();
    },
    filteredClients() {
      const _this = this;
      return _this.clients.filter(c => !_this.keyword || c.name.toLowerCase().includes(_this.keyword) ||
          c.brand?.some(b => b.name.toLowerCase().includes(_this.keyword))).map(c => {
        c.openBrands = !!_this.keyword && c.brand?.some(b => b.name.toLowerCase().includes(_this.keyword))
        return c;
      });
    },
  }
}
</script>
